import React, { Component } from "react";
import axios from "axios";
import { Card, FormControl, Grid, InputLabel, MenuItem, Select } from "@mui/material";
import { Link } from "react-router-dom";
import Constants from "Helpers/Constants";
import init from "Helpers/WindowToken";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import MDSnackbar from "components/MDSnackbar";

export default class LiveTests extends Component {
  state = {
    liveTests: [],
    loading: false,
    notification: false,
    message: "",
    notiColor: "success",
    updatingStatusId: "",
  };

  componentDidMount() {
    this.getAllLiveTests();
  }

  showMessage = (message, notiColor = "success") => {
    this.setState({ notification: true, message, notiColor });
    setTimeout(() => {
      this.setState({ notification: false, message: "", notiColor: "success" });
    }, 3000);
  };

  getAllLiveTests = async () => {
    this.setState({ loading: true });

    try {
      if (init() === "success") {
        const resp = await axios.get(Constants.getUrls.getAllLiveTests);
        this.setState({
          liveTests: resp?.data?.data?.docs || [],
          loading: false,
          updatingStatusId: "",
        });
      } else {
        this.setState({ loading: false });
      }
    } catch (err) {
      this.setState({ loading: false, updatingStatusId: "" });
      this.showMessage(err?.response?.data?.message || "Unable to load live tests.", "error");
    }
  };

  updateLiveTestStatus = async (liveTestId, payload) => {
    if (init() !== "success") {
      return;
    }

    this.setState({ updatingStatusId: liveTestId });

    try {
      const resp = await axios.put(`${Constants.putUrls.updateLiveTestStatus}${liveTestId}`, payload);
      this.showMessage(resp?.data?.message || "Live test status updated successfully.");
      this.getAllLiveTests();
    } catch (err) {
      this.setState({ updatingStatusId: "" });
      this.showMessage(
        err?.response?.data?.message || "Unable to update live test status.",
        "error"
      );
    }
  };

  handleDelete = async (id) => {
    if (!window.confirm("Delete this live test? This will be a soft delete.")) {
      return;
    }

    try {
      const resp = await axios.delete(`${Constants.deleteUrls.deleteLiveTest}${id}`);
      this.showMessage(resp?.data?.message || "Live test deleted successfully.");
      this.getAllLiveTests();
    } catch (err) {
      this.showMessage(err?.response?.data?.message || "Unable to delete live test.", "error");
    }
  };

  render() {
    return (
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox pt={6} pb={3}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
            >
              <MDTypography variant="h6" color="white">
                Live Tests
              </MDTypography>
            </MDBox>

            <Grid item sm={12} px={2} py={2} align="right">
              <Link to="/addLiveTest">
                <MDButton variant="contained" size="small" color="primary">
                  Create Live Test
                </MDButton>
              </Link>
            </Grid>

            <MDBox py={3}>
              {this.state.loading ? (
                <Grid align="center">
                  <h4>Loading...</h4>
                </Grid>
              ) : this.state.liveTests.length > 0 ? (
                <DataTable
                  table={{
                    columns: [
                      { Header: "#", accessor: "serial", width: "5%" },
                      { Header: "title", accessor: "title" },
                      { Header: "entry", accessor: "payment" },
                      { Header: "stage", accessor: "live_status" },
                      { Header: "visibility", accessor: "status" },
                      { Header: "timer", accessor: "timer" },
                      { Header: "poster", accessor: "poster" },
                      { Header: "action", accessor: "action" },
                    ],
                    rows: this.state.liveTests.map((item, index) => ({
                      serial: index + 1,
                      title: item?.title || item?.test_name,
                      payment:
                        item?.payment_type === "paid"
                          ? `Paid • ₹ ${Number(item?.offer_price || item?.price || 0)}${
                              Number(item?.price || 0) > Number(item?.offer_price || 0)
                                ? ` (MRP ₹ ${Number(item?.price || 0)})`
                                : ""
                            }`
                          : "Free",
                      live_status: (
                        <FormControl fullWidth size="small">
                          <InputLabel>Stage</InputLabel>
                          <Select
                            value={item?.live_test_status || "upcoming"}
                            label="Stage"
                            disabled={this.state.updatingStatusId === item?._id}
                            onChange={(e) =>
                              this.updateLiveTestStatus(item?._id, {
                                live_test_status: e.target.value,
                              })
                            }
                          >
                            <MenuItem value="upcoming">Upcoming</MenuItem>
                            <MenuItem value="live">Live</MenuItem>
                            <MenuItem value="completed">Completed</MenuItem>
                            <MenuItem value="cancelled">Cancelled</MenuItem>
                          </Select>
                        </FormControl>
                      ),
                      status: (
                        <FormControl fullWidth size="small">
                          <InputLabel>Status</InputLabel>
                          <Select
                            value={item?.status || "inactive"}
                            label="Status"
                            disabled={this.state.updatingStatusId === item?._id}
                            onChange={(e) =>
                              this.updateLiveTestStatus(item?._id, { status: e.target.value })
                            }
                          >
                            <MenuItem value="active">Active</MenuItem>
                            <MenuItem value="inactive">Inactive</MenuItem>
                          </Select>
                        </FormControl>
                      ),
                      timer: `${Number(item?.default_question_time_seconds || 30)} sec/q`,
                      poster: item?.small_poster ? (
                        <img
                          src={Constants.imageDomain + item.small_poster}
                          style={{ height: "80px", width: "160px", objectFit: "cover" }}
                          alt={item?.title || "live test"}
                        />
                      ) : (
                        "No image"
                      ),
                      action: (
                        <>
                          <Link to={`/update-live-test/${item?._id}`}>
                            <MDButton variant="outlined" size="small" color="secondary" sx={{ mr: 1 }}>
                              Edit
                            </MDButton>
                          </Link>
                          <Link to={`/import-live-test-questions/${item?._id}`}>
                            <MDButton variant="outlined" size="small" color="info" sx={{ mr: 1 }}>
                              Import Questions
                            </MDButton>
                          </Link>
                          <Link to={`/live-test-leaderboard/${item?._id}`}>
                            <MDButton variant="outlined" size="small" color="success" sx={{ mr: 1 }}>
                              Leaderboard
                            </MDButton>
                          </Link>
                          <MDButton
                            variant="outlined"
                            size="small"
                            color="error"
                            onClick={() => this.handleDelete(item?._id)}
                          >
                            Delete
                          </MDButton>
                        </>
                      ),
                    })),
                  }}
                />
              ) : (
                <div>No Data Found!</div>
              )}
            </MDBox>

            <MDSnackbar
              color={this.state.notiColor}
              icon="notifications"
              title="AgriQuiz"
              content={this.state.message}
              dateTime="Just now"
              open={this.state.notification}
            />
          </Card>
        </MDBox>
      </DashboardLayout>
    );
  }
}
